export const EVENT_TYPES = {
  BOOTCAMP: "bootcamp",
  IMPACT_FEST: "impact_fest",
};

export const EVENT_DISPLAY_NAMES = {
  [EVENT_TYPES.BOOTCAMP]: "Boot-Camp Program",
  [EVENT_TYPES.IMPACT_FEST]: "AI India Impact Festival",
};

export const IMPACT_FEST_CATEGORIES = {
  IMPACT_CREATOR: "impact_creator",
  IMPACT_NURTURER: "impact_nurturer",
  IMPACT_SHAPER: "impact_shaper",
};

export const IMPACT_FEST_CATEGORIES_DISPLAY_NAMES = {
  [IMPACT_FEST_CATEGORIES.IMPACT_CREATOR]: "Impact Creator",
  [IMPACT_FEST_CATEGORIES.IMPACT_NURTURER]: "Impact Nurturer",
  [IMPACT_FEST_CATEGORIES.IMPACT_SHAPER]: "Impact Shaper",
};
